import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { InsuranceActions, InsuranceActionTypes } from '../_actions/insurance.actions';
import { QueryParamsModel } from '../../_base/crud';
import { Insurance } from '../_models/insurance.model';

// tslint:disable-next-line:no-empty-interface
export interface InsurancesState extends EntityState<Insurance> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedInsuranceId: number;
  lastQuery: QueryParamsModel;
  error: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Insurance> = createEntityAdapter<Insurance>();

export const initialInsurancesState: InsurancesState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedInsuranceId: undefined,
  showInitWaitingMessage: true,
});

export function insurancesReducer(
  state = initialInsurancesState,
  action: InsuranceActions,
): InsurancesState {
  switch (action.type) {
    case InsuranceActionTypes.InsurancesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedInsuranceId: undefined,
      };
    case InsuranceActionTypes.InsurancesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case InsuranceActionTypes.InsuranceOnServerCreated:
      return {
        ...state,
      };
    case InsuranceActionTypes.InsuranceOnServerUpdated:
      return {
        ...state,
      };
    case InsuranceActionTypes.InsuranceOnServerDeleted:
      return {
        ...state,
      };
    case InsuranceActionTypes.InsuranceCreated:
      return adapter.addOne(action.payload.insurance, {
        ...state,
        lastCreatedInsuranceId: action.payload.insurance.id,
      });
    case InsuranceActionTypes.InsuranceUpdated:
      return adapter.updateOne(action.payload.partialInsurance, state);

    case InsuranceActionTypes.InsuranceDeleted:
      return adapter.removeOne(action.payload.id, state);
    case InsuranceActionTypes.InsurancesPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case InsuranceActionTypes.InsurancesPageLoaded: {
      return adapter.addMany(action.payload.insurances, {
        ...initialInsurancesState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    case InsuranceActionTypes.ThrowInsuranceError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case InsuranceActionTypes.ClearInsuranceErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getInsuranceState = createFeatureSelector<InsurancesState>('insurances');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
